<template>
    <TabelaComp
    tituloCard="Entrada"
    :items="getItemsEntrada()"
    :headers="headers"
    tipo="entrada"
    :status="getStatusEntrada()" />
</template>

<script>
import { mapGetters } from 'vuex'
import TabelaComp from './TabelaComp'

export default {
    name: 'EntradaComp',

    components: {
    TabelaComp
    },

    data: () => ({
    headers: [
        { text: 'Código', value: 'id' },
        { text: 'Descrição', value: 'divida.descricao' },
        { text: 'Valor Parcela', value: 'valor_parcela' },
        { text: 'Quantidade de Parcelas', value: 'divida.num_parcelas' },
        { text: 'Status', value: 'status_pago' },
        { text: 'Açôes', value: 'actions' },
    ]
    }),

    methods: {
    ...mapGetters(['getItemsEntrada', "getStatusEntrada"])
    }

}
</script>
  